import { Userpilot } from 'userpilot';

import { getUserData } from '@uptime/shared/utils/general';

const PROD = 'production';
if (import.meta.env.VITE_ENV === PROD) {
  Userpilot.initialize(import.meta.env.VITE_USER_PILOT_ID);
}

type Props = {
  userId: string;
  team: string;
  profile: any;
  businessProfile: any;
};

export const initialize = ({ userId, team, profile, businessProfile }: Props) => {
  if (import.meta.env.VITE_ENV !== PROD) return;

  const { businessName, userFullName } = getUserData({ profile, businessProfile });

  Userpilot.identify(userId, {
    name: userFullName,
    email: profile?.baseUser?.email,
    company: {
      id: profile?.accountId,
      name: businessName,
    },
    team,
  });
};

export const reload = () => {
  if (import.meta.env.VITE_ENV !== PROD) return;

  Userpilot.reload();
};
